export default __webpack_public_path__ + "static/media/circle_checked.2b03a731.svg";